var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectGateway && !_vm.desktopDisabled)?_c('div',{ref:"vncclient",staticClass:"vnc-client vnc-container"}):_c('div',[_c('a-empty',{staticStyle:{"margin-top":"100px"},attrs:{"description":"该功能不支持此类型网关"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }